import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import { Button } from '@ahaui/react';
import sizesButton from 'src/examples/Button/size';
import widthDefault from 'src/examples/Button/widthDefault';
import brandMicrosoft from 'src/examples/Button/brandMicrosoft';
import brandGoogle from 'src/examples/Button/brandGoogle';
import groupStylesButton from 'src/examples/Button/groupStyles';
import groupIconsButton from 'src/examples/Button/groupIcons';
import groupSizesButton from 'src/examples/Button/groupSizes';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  Button,
  sizesButton,
  widthDefault,
  brandMicrosoft,
  brandGoogle,
  groupStylesButton,
  groupIconsButton,
  groupSizesButton,
  React
};